<app-header [user]="user()" />

<app-about-us-top />
<app-about-us-description />
<app-about-us-pillars />
<app-about-us-brands />
<app-newsletter-section />
